module.exports = __webpack_public_path__ + "static/img/mypage__point__img.9230e4b2.svg";